/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ e: NonNullable<unknown> }} Intervention_Plan_Copy_Plan_ErrorInputs */



/**
* | output |
* | --- |
* | "An error occurred while copying the plan: {e}" |
*
* @param {Intervention_Plan_Copy_Plan_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_copy_plan_error = /** @type {((inputs: Intervention_Plan_Copy_Plan_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Copy_Plan_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`An error occurred while copying the plan: ${i?.e}`)
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la copie du plan: ${i?.e}`)
});